export default __webpack_public_path__ + "static/media/2.cf0c16f8.JPG";